import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';

import TopPage from './pages/Top';
import SampleListPage from '@/pages/SampleListPage';

import GlobalHeader from '@/components/organisms/GlobalHeader';
import AuthComponents from '@/components/auth/AuthComponents';

import '@/utils/apiUtil';
import * as constants from '@/constants';

// https://github.com/aws-amplify/amplify-ui/pull/1024
// eslint-disable-next-line import/no-unresolved
import '@aws-amplify/ui-react/styles.css';
import '@/styles/amplify-ui.css';

Amplify.configure({
  Auth: constants.cognitoAuthConfig,
});

const App: React.FC = () => {
  return (
    <Authenticator components={AuthComponents}>
      {({ signOut, user }) => (
        <div className="App">
          <BrowserRouter>
            <GlobalHeader signOut={signOut} />
            <Routes>
              <Route path="/" element={<TopPage />} />
              <Route path="/feature1" element={<SampleListPage />} />
              <Route path="/feature2" element={<SampleListPage />} />
              <Route path="/feature3" element={<SampleListPage />} />
              <Route path="/feature4" element={<SampleListPage />} />
              <Route path="/feature5" element={<SampleListPage />} />
              <Route path="*" element={<div>Not Found.</div>} />
            </Routes>
          </BrowserRouter>
        </div>
      )}
    </Authenticator>
  );
};

export default App;
